<template>
    <div class="cc-step">
        <div class="cc-content cc-content--alerts" v-if="isCartEmpty">
            <div class="cc-alert cc-alert--warning">{{ translations['Your shopping cart is empty'] }}</div>
        </div>
        <div class="cc-content cc-content--products" v-if="!isCartEmpty">
            <product v-for="product in products" v-bind:key="createProductKey(product)" :product="product" :isEditable="true"/>
        </div>
        <div class="cc-content cc-content--product-information" v-if="!isCartEmpty">
            <div class="cc-content cc-content--applied-vouchers">
                <div class="cc-content cc-content--applied-voucher" v-for="voucher in vouchers" v-bind:key="voucher.code">
                    <div class="cc-content cc-content--applied-voucher__name">{{ voucher.name }}</div>
                    <div class="cc-content cc-content--applied-voucher__value">{{ voucher.value }}</div>
                    <div class="cc-content cc-content--applied-voucher__controls"><i class="icon-trash" @click="removeVoucher(voucher.code)" :title="translations['Remove voucher']"></i></div>
                </div>
            </div>
            <div class="cc-content cc-content--price-tax-excluded">
                <div class="cc-content cc-content--voucher">
                    <voucher/>
                </div>
                <span class="cc-price-label cc-price-label--tax-excluded">{{ translations['Total price tax excluded'] }}</span>
                <span class="cc-price cc-price--tax-excluded">{{ summary.formattedPrices.total_price_tax_excluded }}</span>
            </div>
        </div>
        <div class="cc-content cc-content--price-tax-included" v-if="!isCartEmpty">
            <span class="cc-price-label cc-price-label--tax-included">{{ translations['Total price tax included'] }}</span>
            <span class="cc-price cc-price--tax-included">{{ summary.formattedPrices.total_price_tax_included }}</span>
        </div>
        <div class="cc-content cc-content--free-delivery" v-if="!isCartEmpty">
            <free-delivery/>
        </div>
        <div class="cc-content cc-content--crossselling" v-if="shouldCrossSellingBeShown && this.$root.mobile">
            <cross-selling/>
        </div>
        <div class="cc-content cc-content--controls" v-if="!isCartEmpty">
            <div class="cc-step-controls">
                <div class="cc-step-controls__section cc-step-controls__section--left">
                    <a href="javascript:void(0);"  class="cc-button cc-button--blue" onclick="history.back()">{{ translations['Backward'] }}</a>
                </div>
                <div class="cc-step-controls__section cc-step-controls__section--right">
                    <a href="javascript:void(0);" class="cc-button cc-button--orange" @click="$emit('setActiveStep', activeStep + 1)">{{ translations['Forward'] }}</a>
                </div>
            </div>
        </div>
        <div class="cc-content cc-content--crossselling" v-if="shouldCrossSellingBeShown && this.$root.mobile === false">
            <cross-selling/>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import Product from "./Product";
    import Voucher from "./Voucher";
    import FreeDelivery from "./FreeDelivery";
    import CrossSelling from "./components/CrossSelling/CrossSelling";

    export default {
        components: {
            CrossSelling,
            FreeDelivery,
            Product,
            Voucher,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                products: state => state.products,
                crossSellingProducts: state => state.crossSellingProducts,
                summary: state => state.summary,
                vouchers: state => state.voucher.vouchers,
                activeStep: state => state.activeStep,
            }),
            isCartEmpty: function () {
                return !(this.products && this.products.length > 0);
            },
            shouldCrossSellingBeShown: function () {
                return !this.isCartEmpty && this.crossSellingProducts && this.crossSellingProducts.length > 0;
            },
        },
        methods: {
            createProductKey: function (product) {
                if (product.id_product && product.id_product_attribute) {
                    return product.id_product + '_' + product.id_product_attribute;
                }

                return product.id_product;
            },
            removeVoucher: function (code) {
                this.$store.dispatch('voucher/remove', code)
            }
        },
        name: 'Step1',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-content {
            max-width: 100%;

            &.cc-content--alerts {
                display: block;
                width: 100%;
                margin-top: 5rem;
            }

            &.cc-content--products {
                display: block;
                width: 100%;
                margin-top: 5rem;
            }

            &.cc-content--product-information {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                margin-top: 2.5rem
            }

            &.cc-content--applied-vouchers {
                display: block;
                width: 100%;
            }

            &.cc-content--applied-voucher {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                width: 100%;
            }

            &.cc-content--applied-voucher__name {
                display: block;
                font-weight: bold;
                padding: 2.5rem 1.5rem;
                font-size: 16px;
            }

            &.cc-content--applied-voucher__value {
                display: block;
                font-weight: bold;
                padding: 2.5rem 1.5rem;
                font-size: 16px;
            }

            &.cc-content--applied-voucher__controls {
                display: block;
                font-weight: bold;
                padding: 2.5rem 1.5rem;
                color: $orange;
                font-size: 16px;

                .icon-trash {
                    font-size: 20px;
                    cursor: pointer;
                }
            }

            &.cc-content--price-tax-excluded {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                padding-right: 3rem;
                width: 100%;

                .cc-price-label--tax-excluded {
                    font-size: 16px;
                    width: 45%;
                    text-align: right;
                }

                .cc-price--tax-excluded {
                    font-size: 16px;
                    width: 20%;
                    text-align: right;
                }
            }

            @include mobile {
                &.cc-content--price-tax-excluded {
                    padding: 0rem;

                    .cc-price-label--tax-excluded {
                        padding-left: 2rem;
                        width: 65%;
                        text-align: left;
                    }

                    .cc-price--tax-excluded {
                        width: 35%;
                        padding-right: 2rem;
                    }

                    .cc-content--voucher {
                        margin-bottom: 2rem;
                        .cc-voucher {
                            max-width: 100%;
                        }
                    }
                }
            }

            &.cc-content--voucher {
                display: block;
                width: 35%;
            }

            @include mobile {
                &.cc-content--voucher {
                    width: 100%;
                }
            }

            &.cc-content--price-tax-included {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 2rem;
                padding: 2rem 3rem;
                text-align: right;
                background: $soft-light-grey;

                .cc-price-label--tax-included {
                    font-size: 21px;
                    width: 80%;
                    text-align: right;
                }

                .cc-price--tax-included {
                    font-size: 21px;
                    width: 20%;
                    text-align: right;
                }
            }

            @include mobile {
                &.cc-content--price-tax-included {
                    padding: 2rem;

                    .cc-price-label--tax-included {
                        width: 65%;
                        text-align: left;
                    }

                    .cc-price--tax-included {
                        width: 35%;
                    }
                }
            }

            &.cc-content--free-delivery {
                display: block;
                width: 100%;
                margin-top: 3rem;
                text-align: right;
            }

            &.cc-content--controls {
                display: block;
                width: 100%;
                margin-top: 5rem;
                @include mobile {
                    margin-top: 0;
                }
            }

            &.cc-content--crossselling {
                margin-top: 3rem;
            }
        }
    }
</style>
